import api from './client';
import ApiError from './error';

const AccountService = {
  async searchAccounts({ params }) {
    try {
      const client = await api.getClient();
      return client.searchAccounts(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getAccount({ id }) {
    try {
      const client = await api.getClient();
      return client.getAccount(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createAccount({ account, authentication }) {
    try {
      const client = await api.getClient();
      return client.createAccount(null, { account, authentication });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateAccount({ id, account }) {
    try {
      const client = await api.getClient();

      client.interceptors.response.use((response) => response, (error) => {
        // Redirect after update
        if (error.response?.status === 303) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return client.updateAccount(id, account);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteAccount({ id }) {
    try {
      const client = await api.getClient();
      return client.deleteAccount(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async recoverAccount({ email }) {
    try {
      const client = await api.getClient();
      return client.accountRecover(null, { email });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updatePassword({ id, token, authentication }) {
    try {
      if (token) {
        api.axiosConfigDefaults.headers.Authorization = `Bearer ${token}`;
        await api.init();
      }

      const client = await api.getClient();

      client.interceptors.response.use((response) => response, (error) => {
        if (error.response?.status === 403) {
          return Promise.reject(new Error('Hlekkur útrunninn. Vinsamlegast byrjaðu aftur á ferlinu til að breyta lykilorði.'));
        }

        return Promise.reject(error);
      });

      return client.changeAccountPassword(id, authentication);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async adminUpdatePassword({ id, token, password }) {
    try {
      const client = await api.getClient();

      return client.changeAccountPassword(id, { token, password });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getAccountLogins({ id }) {
    try {
      const client = await api.getClient();
      return client.getAccountLogins(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default AccountService;
